import { Dumbbell } from "lucide-react"

const TypingIndicator = () => {
  return (
    <div className="flex justify-start mb-8">
      <div className="max-w-xs">
        <div className="flex items-center gap-3 mb-3">
          <div className="relative">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 rounded-xl flex items-center justify-center shadow-lg">
              <Dumbbell className="w-5 h-5 text-white" />
            </div>
            <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-400 rounded-full border-2 border-white animate-pulse"></div>
          </div>
          <div>
            <span className="text-sm font-semibold text-gray-700">Metabuddy AI</span>
            <div className="text-xs text-gray-500">...</div>
          </div>
        </div>
        <div className="bg-white/80 backdrop-blur-sm border border-gray-200/50 p-4 rounded-2xl shadow-lg">
          <div className="flex space-x-2">
            <div className="w-3 h-3 bg-gradient-to-r from-blue-400 to-blue-500 rounded-full animate-bounce"></div>
            <div
              className="w-3 h-3 bg-gradient-to-r from-purple-400 to-purple-500 rounded-full animate-bounce"
              style={{ animationDelay: "0.1s" }}
            ></div>
            <div
              className="w-3 h-3 bg-gradient-to-r from-pink-400 to-pink-500 rounded-full animate-bounce"
              style={{ animationDelay: "0.2s" }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TypingIndicator
